/*
 * <sticky-atc> — mobile-only sticky Add-to-Cart bar.
 *
 * Shows once the real buy box has scrolled out of view upward, hides again
 * when the buy box is back on screen or the footer is close. Desktop keeps
 * Dawn's own sticky product-info column, so the bar stays hidden there.
 *
 * The bar carries its own <product-form>, so add-to-cart reuses product-form.js
 * (AJAX add + cart drawer). This element only toggles visibility and reserves
 * layout space on #MainContent while the bar is shown.
 */
if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.mediaQuery = window.matchMedia('(max-width: 749px)');
        this.buyBoxVisible = true;
        this.footerNear = false;
        this.onMediaChange = this.update.bind(this);
      }

      connectedCallback() {
        this.mainContent = document.getElementById('MainContent');
        this.buyBox =
          document.querySelector('.product__info-container product-form') ||
          document.querySelector('.product__info-container .product-form__buttons') ||
          document.querySelector('[id^="ProductSubmitButton-"]');
        this.footer =
          document.querySelector('.shopify-section-group-footer-group') ||
          document.querySelector('.footer');

        // No buy box on the page → nothing to shadow; stay hidden.
        if (!this.buyBox) {
          this.hidden = true;
          return;
        }

        this.buyBoxObserver = new IntersectionObserver(
          (entries) => {
            this.buyBoxVisible = entries[entries.length - 1].isIntersecting;
            this.update();
          },
          { rootMargin: '0px 0px -40px 0px' }
        );
        this.buyBoxObserver.observe(this.buyBox);

        if (this.footer) {
          this.footerObserver = new IntersectionObserver(
            (entries) => {
              this.footerNear = entries[entries.length - 1].isIntersecting;
              this.update();
            },
            { rootMargin: '0px 0px 200px 0px' }
          );
          this.footerObserver.observe(this.footer);
        }

        if (this.mediaQuery.addEventListener) {
          this.mediaQuery.addEventListener('change', this.onMediaChange);
        } else {
          this.mediaQuery.addListener(this.onMediaChange);
        }

        this.update();
      }

      disconnectedCallback() {
        if (this.buyBoxObserver) this.buyBoxObserver.disconnect();
        if (this.footerObserver) this.footerObserver.disconnect();
        if (this.mediaQuery.removeEventListener) {
          this.mediaQuery.removeEventListener('change', this.onMediaChange);
        } else {
          this.mediaQuery.removeListener(this.onMediaChange);
        }
        if (this.mainContent) this.mainContent.classList.remove('sticky-atc-pad');
      }

      update() {
        const show =
          this.mediaQuery.matches && !this.buyBoxVisible && !this.footerNear;
        this.hidden = !show;
        if (this.mainContent) {
          this.mainContent.classList.toggle('sticky-atc-pad', show);
        }
      }
    }
  );
}
